import { z, type ZodErrorMap, ZodIssueCode } from "zod";

const FIELD_LABELS: Record<string, string> = {
  arch: "架构",
  baseUrl: "服务地址",
  bundleVersion: "规则包版本",
  channel: "更新通道",
  deviceLimit: "设备数上限",
  email: "登录邮箱",
  enabled: "启用状态",
  entitlements: "授权能力",
  expiresAt: "到期时间",
  id: "用户 ID",
  maxOutputTokens: "输出上限",
  minCurrentVersion: "最低当前版本",
  model: "模型",
  name: "名称",
  notes: "发布说明",
  ownerEmail: "登录邮箱",
  ownerName: "联系人姓名",
  ownerPassword: "初始密码",
  password: "密码",
  payloadText: "规则包内容",
  plan: "套餐",
  platformKey: "平台键",
  providerKind: "AI 服务类型",
  providerName: "AI 服务名称",
  pubDate: "发布时间",
  requestTimeoutMs: "超时毫秒",
  role: "角色",
  signature: "签名",
  status: "状态",
  target: "系统目标",
  temperature: "随机度",
  url: "下载地址",
  usageType: "计量类型",
  version: "版本"
};

export function installChineseZodErrorMap(): void {
  z.setErrorMap(chineseZodErrorMap);
}

const chineseZodErrorMap: ZodErrorMap = (issue, ctx) => {
  if (issue.message && issue.message !== ctx.defaultError) {
    return { message: issue.message };
  }

  const field = fieldLabel(issue.path);
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === "undefined") {
        return { message: `${field}不能为空` };
      }
      return { message: `${field}类型不正确` };
    case ZodIssueCode.invalid_string:
      if (issue.validation === "email") {
        return { message: `${field}格式不正确` };
      }
      if (issue.validation === "url") {
        return { message: `${field}必须是合法网址` };
      }
      if (issue.validation === "datetime") {
        return { message: `${field}必须是合法日期时间` };
      }
      return { message: `${field}格式不正确` };
    case ZodIssueCode.too_small:
      if (issue.type === "string") {
        return { message: `${field}不能为空` };
      }
      if (issue.type === "array") {
        return { message: `${field}至少需要 ${issue.minimum} 项` };
      }
      return { message: `${field}不能小于 ${issue.minimum}` };
    case ZodIssueCode.too_big:
      if (issue.type === "string") {
        return { message: `${field}不能超过 ${issue.maximum} 个字符` };
      }
      if (issue.type === "array") {
        return { message: `${field}不能超过 ${issue.maximum} 项` };
      }
      return { message: `${field}不能大于 ${issue.maximum}` };
    case ZodIssueCode.invalid_enum_value:
      return { message: `${field}选项不合法` };
    case ZodIssueCode.invalid_literal:
      return { message: `${field}值不合法` };
    case ZodIssueCode.not_finite:
      return { message: `${field}必须是有效数字` };
    default:
      return { message: "输入内容不合法" };
  }
};

function fieldLabel(path: (string | number)[]): string {
  const key = [...path].reverse().find((part): part is string => typeof part === "string");
  return key ? (FIELD_LABELS[key] ?? "该字段") : "该字段";
}
